/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
/*export const environment = {
  production: true,
  apiUrl: 'https://admin.parceleaconta.com.br/v3/web',
  //apiUrl: 'http://127.0.0.1:4048/web',
  title: 'ParceleAConta',
  titleHTML: 'ParceleA<b>Conta</b>',
  footer: '&copy; 2022 ParceleAConta. Ver.: 3.5.0 Build: 20220310 - old-version-v3'
};*/


/*export const environment = {
  production: true,
  apiUrl: 'https://admin.estbank.com.br/v3/web',
  //apiUrl: 'http://127.0.0.1:4048/web',
  title: 'Estbank Parcelador',
  titleHTML: 'Estbank <b>Parcelador</b>',
  footer: '&copy; 2020 Estbank Parcelador. Ver.: 3.4.3 Build: 20201208'
};*/


/*export const environment = {
  production: true,
  apiUrl: 'https://pagnahora.com/v3/web',
  //apiUrl: 'http://127.0.0.1:4048/web',
  title: 'PagNaHora',
  titleHTML: 'PagNa<b>Hora</b>',
  footer: '&copy; 2020 PagNaHora. Ver.: 3.4.3 Build: 20201208'
};*/

export const environment = {
  production: true,
  apiUrl: 'https://admin.obapaguei.com.br/v3/web',
  //apiUrl: 'https://admin.obapaguei.com.br/sandbox/web',
  //apiUrl: 'http://127.0.0.1:4046/web',
  title: 'ObaPaguei',
  titleHTML: 'Oba<b>Paguei</b>',
  footer: '&copy; 2022 ObaPaguei. Ver.: 4.5.2 Build: 20230418 - <small>old-version-v3</small>',
};

/*export const environment = {
  production: true,
  apiUrl: 'https://admin.consorciopay.com.br/v4/web',
  //apiUrl: 'http://localhost:4048/web',
  title: 'ConsórcioPay',
  titleHTML: 'Consórcio<b>Pay</b>',
  footer: '&copy; 2021 ConsórcioPay. Ver.: 3.9.9 Build: 20210830',
};*/


/*export const environment = {
  production: true,
  apiUrl: 'https://consorciopay.com.br/v3/web',
  //apiUrl: 'http://localhost:4048/web',
  title: 'ConsórcioPay',
  titleHTML: 'Consórcio<b>Pay</b>',
  footer: '&copy; 2022 ConsórcioPay. Ver.: 3.9.9 Build: 20210830',
};*/

/*export const environment = {
  production: true,
  apiUrl: 'https://pagamostudo.com.br/v3/web',
  //apiUrl: 'https://admin.obapaguei.com.br/sandbox/web',
  //apiUrl: 'http://127.0.0.1:4048/web',
  title: 'PagamosTudo',
  titleHTML: 'Pagamos<b>Tudo</b>',
  footer: '&copy; 2021 PagamosTudo. Ver.: 3.6.5 Build: 20210430',
};*/

/*export const environment = {
  production: true,
  apiUrl: 'https://admin.estbank.com.br/v3/web',
  //apiUrl: 'http://127.0.0.1:4048/web',
  title: 'Estbank Parcelador',
  titleHTML: 'Estbank <b>Parcelador</b>',
  footer: '&copy; 2021 Estbank Parcelador. Ver.: 3.5.5 Build: 20210308'
};*/

/*export const environment = {
  production: true,
  //apiUrl: 'https://admin.estbank.com.br/sandbox/web',
  apiUrl: 'https://admin.parceleaconta.com.br/v3/web',
  //apiUrl: 'http://127.0.0.1:4048/web',
  title: 'ParceleAConta',
  titleHTML: 'ParceleA<b>Conta</b>',
  footer: '&copy; 2020 ParceleAConta. Ver.: 3.4.8 Build: 20210209'
};*/